import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'
import config from '../config'
import moment from 'moment-timezone'

// Product IDs
const PRODUCT_ID = 'starter_plus_workflow_premium_actions_triggers'

// Helper function to get the current product ID based on timing
const getProductId = () => {
  return PRODUCT_ID
}

// Configure request setup
const serviceName = 'WorkflowsResellingService'
const host = servicesConfig.Reselling as string
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const WorkflowsResellingService = {
  // Properties
  PRODUCT_ID,  
  // Getters implemented as properties and methods
  get productId() {
    return getProductId()
  },
  
  // Methods
  getProductConfiguration: () =>
    request().get(`/product?productCode=${PRODUCT_ID}`)
    .then(responseBody),

  getCompanyResellingConfig: (companyId: string) =>
    request().get(
      `/configuration/company/${companyId}/${PRODUCT_ID}`
    ).then(responseBody),

  updateCompanyResellingConfig: (
    companyId: string,
    data: { amount?: number; offeringEnabled?: boolean; plans?: { planId: string; amount: number }[] },
  ) =>
    request().put(
      `/configuration/company/${companyId}/${PRODUCT_ID}`,
      data
    ).then(responseBody),

  getLocationConfig: (locationId: string) =>
    request().get(
      `/configuration/location/${locationId}/${PRODUCT_ID}`
    ).then(responseBody),

  getLocationSubscriptions: (locationId: string) =>
    request().get(`/subscription/location/${locationId}?paymentStatus=COMPLETE`)
    .then(responseBody),

  updateLocationResellingConfig: (
    locationId: string,
    data: { amount?: number; offeringEnabled?: boolean; plans?: { planId: string; amount: number }[] },
  ) =>
    request().put(
      `/configuration/location/${locationId}/${PRODUCT_ID}`,
      data
    ).then(responseBody),

  agencyDirectPurchase: (locationId: string, planId: string) =>
    request().post(
      `/subscription/location/${locationId}/${PRODUCT_ID}`,
      {
        purchaseStyle: 'COMPANY_DIRECT_PURCHASE',
        planId,
      }
    ).then(responseBody),

  getCompanySubscriptions: (companyId: string) => 
    request().get(`/subscription/company/${companyId}`).then(responseBody)
}

export default WorkflowsResellingService
